import { render, staticRenderFns } from "./InvoicesHistory.vue?vue&type=template&id=43dad5e6&scoped=true&"
import script from "./InvoicesHistory.vue?vue&type=script&lang=js&"
export * from "./InvoicesHistory.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesHistory.vue?vue&type=style&index=0&id=43dad5e6&scoped=true&lang=css&"
import style1 from "./InvoicesHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dad5e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43dad5e6')) {
      api.createRecord('43dad5e6', component.options)
    } else {
      api.reload('43dad5e6', component.options)
    }
    module.hot.accept("./InvoicesHistory.vue?vue&type=template&id=43dad5e6&scoped=true&", function () {
      api.rerender('43dad5e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Customer/InvoicesHistory.vue"
export default component.exports